import React from "react";


const Social = () => {
    return(
        <div>

        </div>
    )
}

export default Social; 